<template>
  <el-tabs type="border-card" class="custom-tab" v-model="activeName">
    <el-tab-pane label="报价型号" name="a">
      <Quotation v-if="activeName === 'a'" :activeName="activeName"/>
    </el-tab-pane>
    <el-tab-pane label="合同型号" name="b">
      <Contract  v-if="activeName === 'b'" :activeName="activeName"/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { defineComponent,ref } from '@vue/composition-api'
import Contract from './contract.vue'
import Quotation from './quotation.vue'


export default defineComponent({
  components: {Contract,Quotation},
  setup() {
    const activeName = ref('a')

    return {
      activeName,
    }
  }

})
</script>
